// extracted by mini-css-extract-plugin
export default {"divider":"Banner_divider__cOuIz","text":"Banner_text__5aZZM","buttons":"Banner_buttons__NZu1M"};